import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = { class: "w-[150px]" }
const _hoisted_3 = {
  key: 0,
  class: "w-[240px]"
}
const _hoisted_4 = {
  key: 1,
  class: "w-[260px]"
}

import { computed } from 'vue'

import { useProfessionalDocumentCatalogStore } from '@/pinia-store/useProfessionalDocumentCatalogStore'
import { ProfessionalSealKey } from '@/types/professional-documents.types'
import {
  QualificationOnFail,
  QualificationRuleField
} from '@/types/qualification-eligibility.types'
import type { QualificationRuleValue } from '@/types/qualification-policy.types'

import OnFailSelector from './OnFailSelector.vue'
import { setCriterionField, setCriterionKey, setCriterionOnFail } from './policyModel'


export default /*#__PURE__*/_defineComponent({
  __name: 'CriterionEditor',
  props: {
    modelValue: {},
    testId: { default: 'qualification-criterion' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;




const change = (value: QualificationRuleValue) => emit('update:modelValue', value)

const catalog = useProfessionalDocumentCatalogStore()

const FIELD_OPTIONS = [
  { title: 'Selo', value: QualificationRuleField.SEAL },
  { title: 'Documento', value: QualificationRuleField.DOCUMENT }
]

// Suporte a Vida é atalho de regra (grupo de ATLS/ACLS/PALS), não selo: o backend recusa
// `{ field: SEAL, key: LIFE_SUPPORT }` (D35, A3.9, ruling R45).
const sealOptions = computed(() =>
  catalog.seals
    .filter((seal) => seal.key !== ProfessionalSealKey.LIFE_SUPPORT)
    .map((seal) => ({ title: seal.name, value: seal.key }))
)
const documentOptions = computed(() =>
  catalog.types.map((type) => ({ title: type.name, value: type.key }))
)

const onField = (field: QualificationRuleField) =>
  change(setCriterionField(props.modelValue, field))
// O autocomplete limpo devolve `null`: o critério volta a ficar incompleto (chave vazia).
const onKey = (key: string | null) => change(setCriterionKey(props.modelValue, key ?? ''))
const onOnFail = (onFail: QualificationOnFail) =>
  change(setCriterionOnFail(props.modelValue, onFail))

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-wrap items-center gap-x-3 gap-y-2 py-1",
    "data-testid": _ctx.testId
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_select, {
        "model-value": _ctx.modelValue?.field ?? null,
        items: FIELD_OPTIONS,
        label: "Campo",
        variant: "outlined",
        density: "compact",
        color: "primary20",
        "hide-details": "",
        class: "bg-white",
        "data-testid": `${_ctx.testId}-field`,
        "onUpdate:modelValue": onField
      }, null, 8, ["model-value", "data-testid"])
    ]),
    (_ctx.modelValue?.field === _unref(QualificationRuleField).SEAL)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_v_select, {
            "model-value": _ctx.modelValue.key || null,
            items: sealOptions.value,
            label: "Selo",
            variant: "outlined",
            density: "compact",
            color: "primary20",
            "hide-details": "",
            class: "bg-white",
            "data-testid": `${_ctx.testId}-seal`,
            "onUpdate:modelValue": onKey
          }, null, 8, ["model-value", "items", "data-testid"])
        ]))
      : (_ctx.modelValue?.field === _unref(QualificationRuleField).DOCUMENT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_v_autocomplete, {
              "model-value": _ctx.modelValue.key || null,
              items: documentOptions.value,
              label: "Documento",
              variant: "outlined",
              density: "compact",
              color: "primary20",
              "hide-details": "",
              class: "bg-white",
              "no-data-text": "Nenhum tipo no catálogo",
              "data-testid": `${_ctx.testId}-document`,
              "onUpdate:modelValue": onKey
            }, null, 8, ["model-value", "items", "data-testid"])
          ]))
        : _createCommentVNode("", true),
    _createVNode(OnFailSelector, {
      "model-value": _ctx.modelValue?.onFail ?? _unref(QualificationOnFail).BLOCK,
      "test-id": `${_ctx.testId}-on-fail`,
      "onUpdate:modelValue": onOnFail
    }, null, 8, ["model-value", "test-id"])
  ], 8, _hoisted_1))
}
}

})